import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../../src/navbar';
import { productsService } from '../../services/api/products.service';
import { config, buildImageUrl } from '../../config';

function CategoryProducts() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch category details
        const categoryData = await productsService.getCategoryById(id);
        setCategory(categoryData);

        // Fetch products for this category
        const productsData = await productsService.getProductsByCategory(id);
        setProducts(Array.isArray(productsData) ? productsData : []);
      } catch (err) {
        setError((err && (err.message || err.error)) || String(err));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return (
    <>
      <div className="flex">
        <Navbar />
      </div>
      <div className="max-w-6xl mx-auto p-4 mt-20">
        {loading && <div className="text-center">Loading...</div>}
        {error && <div className="text-red-600">{error}</div>}

        {!loading && !error && (
          <>
            <h1 className="text-2xl font-bold mb-6">{category?.name || 'Category Products'}</h1>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {products.map((product) => (
                <div key={product._id} className="border rounded overflow-hidden">
                  <img 
                    src={product.images && product.images[0] ? buildImageUrl(product.images[0]) : config.defaultImage} 
                    alt={product.name}
                    className="w-full h-48 object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = config.defaultImage;
                    }}
                  />
                  <div className="p-4">
                    <h3 className="font-semibold text-lg">{product.name}</h3>
                    <p className="text-gray-600 mt-1">{product.description}</p>
                    <p className="text-blue-600 font-semibold mt-2">₹{product.price}</p>
                  </div>
                </div>
              ))}
            </div>

            {products.length === 0 && !loading && (
              <div className="text-center text-gray-600 mt-8">
                No products found in this category
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default CategoryProducts;